import SimpleReactValidator from 'shared/utils/simple-react-validator';
import { toast } from 'react-hot-toast';
import { TAB_FABRICATION } from 'shared/product_tabs/tabs/tabType';
import { PRICE_SELECTED } from 'shared/data/quoteSteps';
import { updateValidatorFlag } from 'us_full_feature_pcb/pcb_fabrication/slice/fabricationSlice';
import { changeTab } from 'shared/product_tabs/tabs/tabSlice';

export const validator = new SimpleReactValidator({});

export const validatorProject = new SimpleReactValidator({});

export const arrayValidator = new SimpleReactValidator({});

export const validate = () => (dispatch, getState) => {
  const { quoteStep, parametersChanged } = getState().fabrication;

  let validateResult = true;

  if (quoteStep === PRICE_SELECTED) {
    if (!validator.allValid()) {
      validator.showMessages();
      dispatch(updateValidatorFlag());
      dispatch(changeTab(TAB_FABRICATION));
      toast.error('Please fix the errors in the Fabrication form');
      validateResult = false;
    } else if (parametersChanged) {
      toast('One or more parameters have changed. Please get a new Fabrication quote', { type: 'warning' });
      dispatch(changeTab(TAB_FABRICATION));
      validateResult = false;
    }
  }

  return validateResult;
};

export const validateProject = () => (dispatch) => {
  let validateResult = true;

  if (!validatorProject.allValid()) {
    validatorProject.showMessages();
    toast.error(Spree.translations.project_errors);
    dispatch(updateValidatorFlag());
    validateResult = false;
  }

  return validateResult;
};
